import { PdfBatchGenerationComponent } from './pdf-batch-generation.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const pdfBatchGenerationRoutes: Routes = [
  {
    path: 'admin/rdn-generation',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'PDF_BATCH_GENERATION',
        redirectTo: '/',
      },
    },
    children: [{ path: '', component: PdfBatchGenerationComponent }],
  },
]
